import { useContext } from "react";
import { Route, Routes } from "react-router-dom";
import AvailabilityReport from "./component/availability/component/AvailabilityReport";
import AvailabilityReportOld from "./component/availability/component/AvailabilityReportOld";
import AvailabilityReportForecast from "./component/availabilityForecast/component/AvailabilityReportForecast";
import AttachmentsVehiclePlanning from "./page/AttachmentVehiclePage";
import BrandPlanning from "./page/BrandPlanning";
import CarCompanyPage from "./page/CarCompanyPage";
import { CarMaintenance } from "./page/CarMaintenance";
import FleetPlanning from "./page/FleetPlanning";
import { ImportTransportationListPage } from "./page/ImportTransportationListPage";
import InsurancePlanning from "./page/InsurancePlanning";
import { MdVehicle } from "./page/MdVehicle";
import { ModelsCar } from "./page/ModelsCar";
import OutfittingPlanning from "./page/OutfittingPlanning";
import { RangeCar } from "./page/RangeCar";
import RfidCardPage from "./page/RdifCardPage";
import { SapPage } from "./page/SapPage";
import { SupplierPage } from "./page/SupplierPage";
import { StatusReasonPage } from "./page/StatusReasonPage";
import VehicleCategoriesPlanning from "./page/VehicleCategoriesPlanning";
import VehiclePage from "./page/VehiclePage";

import Box from "@mui/material/Box";
import CustomLoader from "../../util/component/CustomLoader";
import {
  ContextOperation,
  ProviderOperation,
} from "./context/OperationContext";
import CarrierPage from "./page/CarrierPage";
import DamageFormPage from "./page/DamageFormPage";
import DamagePage from "./page/DamagePage";
import { DeliveryNotePage } from "./page/DeliveryNotePage";
import EquipmentPage from "./page/Equipment";
import EquipmentAssociation from "./page/EquipmentAssociation";
import SupplierCustomGroupLocationPage from "./page/SupplierCustomGroupLocation";
import LogisticCompoundPage from "./page/LogisticCompoundPage";
import StatusReportPage from "./page/StatusReportPage";
import { TransportPage } from "./page/TransportPage";
import VehicleAvailabilityPage from "./page/VehicleAvailabilityPage";
import VehicleEntrancePage from "./page/VehicleEntrancePage";
import VehicleExitPage from "./page/VehicleExitPage";
import DriverPage from "./page/DriversPage";
import { TransactionHistoryPage } from "./page/TransactionHistoryPage";
import DamagePricePage from "./page/DamagePricePage";
import MissingEquipmentsPage from "./page/MissingEquipmentsPage";
import VehicleToBeRepairedPage from "./page/VehicleToBeRepairedPage";
import TransferRequestMainPage from "./page/TransferRequestMainPage";
import { VehicleTransferPage } from "./page/VehicleTransferPage";
import TestPageCheckInOut from "./component/testCheckInOut/TestPageCheckInOut";
import Maintenance from "./page/Maintenance";
import VehicleInspectionPage from "./page/VehicleInspectionPage";
import RfidCardImportTracking from "./component/rfidCardImport/RfidCardImportTracking";
import ExportPage from "./component/exports/ExportPage";

const Loader = () => {
  const { loading } = useContext(ContextOperation);

  return <CustomLoader loading={loading} />;
};

const OperationMain = () => {
  return (
    <ProviderOperation>
      <Box>
        <Routes>
          <Route path="/planning/*" element={<FleetPlanning />} />

          <Route path="/availability/report/*" element={<AvailabilityReport />} />
		  <Route path="/availability/report_old/*" element={<AvailabilityReportOld />} />

          <Route path="/availability/reportForecast/*" element={<AvailabilityReportForecast />} />
          <Route path="/availability/locationReport/*" element={<StatusReportPage />} />

          <Route path="/vehicles/list/*" element={<VehiclePage />} />
          <Route path="/vehicles/brands/*" element={<BrandPlanning />} />
          <Route path="/vehicles/models/*" element={<ModelsCar />} />
          <Route path="/vehicles/companies/*" element={<CarCompanyPage />} />
          <Route path="/vehicles/ranges/*" element={<RangeCar />} />
          <Route path="/vehicles/categories/*" element={<VehicleCategoriesPlanning />} />
          <Route path="/vehicles/outfittings/*" element={<OutfittingPlanning />} />
          <Route path="/vehicles/insurances/*" element={<InsurancePlanning />} />
          <Route path="/vehicles/services/*" element={<CarMaintenance />} />
          <Route path="/vehicles/inspections/*" element={<VehicleInspectionPage />} />
          <Route path="/vehicles/rfidCard/*" element={<RfidCardPage />} />
          <Route path="/vehicles/statusReasons/*" element={<StatusReasonPage />} />
          <Route path="/vehicles/availabilityManagement/*" element={<VehicleAvailabilityPage />} />
          <Route path="/vehicles/transactionHistory/*" element={<TransactionHistoryPage />} />
          <Route path="/vehicles/equipments/list/*" element={<EquipmentPage />} />
          <Route path="/vehicles/equipments/kit/*" element={<EquipmentAssociation />} />
          <Route path="/vehicles/sapImport/*" element={<SapPage />} />
          <Route path="/vehicles/maintenance/*" element={<Maintenance />} />
          <Route path="/vehicles/exports" element={<ExportPage  
                                                        exportType='VEHICLE'
                                                  />} />
          <Route path="/vehicles/massiveLockResultExport" element={<ExportPage  
                                                        exportType='MASSIVE_VEHICLE_LOCK'
                                                  />} />

          <Route path="/damages/list/*" element={<DamagePricePage />} />
          <Route path="/damages/forms/*" element={<DamageFormPage />} />
          <Route path="/damages/prices/*" element={<DamagePage />} />
          <Route path="/damages/toBeRepaired/*" element={<VehicleToBeRepairedPage />} />
          <Route path="/damages/missingEquipments/*" element={<MissingEquipmentsPage />} />
          <Route path="/damages/damageFormExport/*" element={<ExportPage  
                                                        exportType='DAMAGE_FORM'
                                                  />} />
          <Route path="/damages/accidentsFromDrivaliaResultExport/*" element={<ExportPage  
                                                        exportType='RECEIVE_FROM_LEASYS'
                                                  />} />

          <Route path="/suppliers/carriers/*" element={<CarrierPage />} />
          <Route path="/suppliers/transportator/*" element={<TransportPage />} />
          <Route path="/suppliers/logisticCompounds/*" element={<LogisticCompoundPage />} />
          <Route path="/suppliers/carriersPriceImportTracking/*" element={<ImportTransportationListPage />} />
          <Route path="/suppliers/sapImport/*" element={<SupplierPage />} />
          <Route path="/suppliers/customGroupLocations" element={<SupplierCustomGroupLocationPage />} />

          <Route path="/transfer/transferRequests/*" element={<TransferRequestMainPage />} />
          <Route path="/transfer/transferRequestsExport" element={<ExportPage  
                                                        exportType='TRANSFER_REQUEST'
                                                  />} />
          <Route path="/transfer/deliveryNotes/*" element={<DeliveryNotePage />} />
          <Route path="/transfer/deliveryNotesExport" element={<ExportPage  
                                                        exportType='DELIVERY_NOTE'
                                                  />} />
          <Route path="/transfer/drivers/*" element={<DriverPage />} />
		  
		  {/* Non è visibile nel menu, rimossa in LPP-13022 */}
          {false && <Route path="/transfer/vehiclesTransfer/*" element={<VehicleTransferPage />} />}
		  
          <Route path="/transfer/vehiclesEntrance/*" element={<VehicleEntrancePage />} />
          <Route path="/transfer/vehiclesExit/*" element={<VehicleExitPage />} />
                                                  

          {false && <Route path="/mdvehicle/*" element={<MdVehicle />} />}
          <Route path="/attachment/:id" element={<AttachmentsVehiclePlanning />} />
          {false && <Route path="/customGroupLocations" element={<SupplierCustomGroupLocationPage />} />}
          {false && <Route path="/inspections/*" element={<VehicleInspectionPage />} />}
          {/* Non è visibile nel menu, pagina di test */}
          {false && <Route path="/testCheckInOut/*" element={<TestPageCheckInOut />} />}
          {false && <Route path="/vehiclemaintenance/*" element={<Maintenance />} />}
		  
		  		        <Route path="/vehicles/rfidCardImportTracking/*" element={<RfidCardImportTracking />} />

        </Routes>
        

        <Loader />
      </Box>
    </ProviderOperation>
  );
};

export default OperationMain;
